import { useContext } from "react";
import { ResourceContext, ResourceContextValue } from "./ResourceContext";

export const useResourceContext = (): ResourceContextValue => {
  const context = useContext(ResourceContext);

  return context;
};
